<!-- [画面下部固定フローティングナビ] -->
<div class="l-bottom-float">
  <div *ngIf="!isPc" class="p-bottom-float-function-icon">
    <div class="p-bottom-float-function-icon__item p-bottom-float-function-icon__item--right01">
      <asw-add-to-favorite [isPc]="isPc"></asw-add-to-favorite>
    </div>
  </div>
  <!-- [PC/TAB用 下部固定エリア内金額表示エリア] -->
  <div *ngIf="!isSp" class="p-bottom-float-navi02 p-bottom-float-navi02--has-promotion">
    <div class="p-bottom-float-navi02__wrap">
      <div class="p-bottom-float-navi02__inner">
        <div class="p-bottom-float-navi02__item">
          <div class="p-bottom-float-navi02__detail">
            <ng-container *ngIf="isPromotionApplied">
              <div class="p-bottom-float-navi02__detail-promotion">
                <span class="c-promotion-applied"
                  ><img
                    class="c-promotion-applied__img"
                    src="assets/images/icon_promotion_applied_20.svg"
                    width="20"
                    height="20"
                    alt="{{ 'label.promotionApplied' | staticMsg }}"
                /></span>
              </div>
            </ng-container>
            <div
              class="p-bottom-float-navi02__detail-price"
              [innerHTML]="totalPrice | amountFormat : 'availability.bottomFloat_totalPrice' : currencyCode"
            ></div>
            <div class="p-bottom-float-navi02__detail-link">
              <a
                href="#"
                id="complex-flight-availability-pres-details"
                class="c-text-link-arrow01 c-text-link-arrow01--ss"
                (throttleClick$)="details($event)"
                aswThrottleClick
              >
                {{ 'm_static_message-label.details2' | staticMsg }}
              </a>
            </div>
            <ng-container *ngIf="isPromotionApplied">
              <div class="p-bottom-float-navi02__detail-del">
                <del [innerHTML]="originalTotalPrice | amountFormat : 'default' : currencyCode"></del>
              </div>
            </ng-container>
            <div
              class="p-bottom-float-navi02__detail-info"
              [innerHTML]="'m_static_message-label.includeFareAndFuelCost' | staticMsg"
            ></div>
          </div>
        </div>
        <div class="p-bottom-float-navi02__item">
          <div class="p-bottom-float-navi02__miles" *ngIf="isMilesDisplay">
            {{ this.accrualMiles | amountFormat : 'default' : 'MIL' }}
            <span>({{ 'm_static_message-label.passenger2' | staticMsg }})</span>
          </div>
          <button
            id="complex-flight-availability-pres-continue"
            class="c-btn-primary c-btn-primary--min-w100 c-btn-primary--sp-s"
            (throttleClick$)="clickNextButton($event)"
            aswThrottleClick
          >
            <span class="c-btn-primary__text">{{ 'm_static_message-label.next' | staticMsg }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- [PC/TAB用 下部固定エリア内金額表示エリア] -->

  <!-- [SP用 下部固定エリア内金額表示エリア] -->
  <div *ngIf="isSp" class="p-bottom-float-navi03 p-bottom-float-navi03--has-promotion">
    <div class="p-bottom-float-navi03__miles" *ngIf="isMilesDisplay">
      <div class="p-bottom-float-navi03__miles-inner">
        {{ this.accrualMiles | amountFormat : 'default' : 'MIL' }}
        <span>({{ 'm_static_message-label.passenger2' | staticMsg }})</span>
      </div>
    </div>
    <div class="p-bottom-float-navi03__wrap">
      <div class="p-bottom-float-navi03__inner">
        <div class="p-bottom-float-navi03__item">
          <div class="p-bottom-float-navi03__detail">
            <div *ngIf="isPromotionApplied" class="p-bottom-float-navi03__detail-promotion">
              <span class="c-promotion-applied"
                ><img
                  class="c-promotion-applied__img"
                  src="assets/images/icon_promotion_applied_20.svg"
                  width="20"
                  height="20"
                  alt="{{ 'label.promotionApplied' | staticMsg }}"
              /></span>
            </div>
            <div
              class="p-bottom-float-navi03__detail-price"
              [innerHTML]="totalPrice | amountFormat : 'availability.bottomFloat_totalPrice' : currencyCode"
            ></div>
            <div class="p-bottom-float-navi03__detail-link">
              <a
                href="#"
                id="complex-flight-availability-pres-details2"
                class="c-text-link-arrow01 c-text-link-arrow01--ss"
                (throttleClick$)="details($event)"
                aswThrottleClick
                >{{ 'm_static_message-label.details2' | staticMsg }}</a
              >
            </div>
            <div *ngIf="isPromotionApplied" class="p-bottom-float-navi03__detail-del">
              <del [innerHTML]="originalTotalPrice | amountFormat : undefined : currencyCode"></del>
            </div>
            <div
              class="p-bottom-float-navi03__detail-info"
              [innerHTML]="'m_static_message-label.includeFareAndFuelCost' | staticMsg"
            ></div>
          </div>
        </div>
        <div class="p-bottom-float-navi03__item">
          <button
            id="complex-flight-availability-pres-continue-sp"
            class="c-btn-primary c-btn-primary--min-w100 c-btn-primary--sp-s"
            (throttleClick$)="clickNextButton($event)"
            aswThrottleClick
          >
            <span class="c-btn-primary__text">{{ 'm_static_message-label.next' | staticMsg }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- [SP用 下部固定エリア内金額表示エリア] -->
</div>
